import ko from "knockout";
import _ from "lodash";
import $ from "jquery";
import keyCode from "util/keyCode";
import i18n from "extensions/i18n/knockout.i18n";

const EVENT_NAMESPACE = ".flipswitch-evt";
const FLIPSWITCH_CLASS = "flipswitch";
const FLIPSWITCH_ANIMATION_CLASS = "flipswitch-animate";

const FLIPSWITCH_ON_CLASS = "flipswitch-on";
const FLIPSWITCH_OFF_CLASS = "flipswitch-off";

const FLIPSWITCH_DISABLED_CLASS = "flipswitch-disabled";

const ON_MESSAGE_KEY = "flipswitch.on";
const OFF_MESSAGE_KEY = "flipswitch.off";

const setOn = function ($element) {
    $element.removeClass(FLIPSWITCH_OFF_CLASS);
    $element.addClass(FLIPSWITCH_ON_CLASS);
};

const setOff = function ($element) {
    $element.removeClass(FLIPSWITCH_ON_CLASS);
    $element.addClass(FLIPSWITCH_OFF_CLASS);
};

const createFlipswitchDOM = function ($element, options) {
    $element.addClass(FLIPSWITCH_CLASS);
    $element.attr("tabIndex", 0);

    const onMessageKey = options.onLabelKey || ON_MESSAGE_KEY;
    const offMessageKey = options.offLabelKey || OFF_MESSAGE_KEY;

    //
    // Create the Flipswitch DOM
    //
    $("<span/>", { class: "fs-state fs-state-inactive" })
        .append(
            $("<span/>", {
                class: "fs-label",
                text: i18n.renderString(offMessageKey),
            })
        )
        .appendTo($element);

    $("<span/>", { class: "fs-state fs-state-active" })
        .append(
            $("<span/>", {
                class: "fs-label",
                text: i18n.renderString(onMessageKey),
            })
        )
        .appendTo($element);

    $("<button/>", {
        class: "fs-btn",
        type: "button",
        tabIndex: "-1", // the whole switch will get focus, not the button inside it
    }).appendTo($element);

    //
    // Determine the width of the Flipswitch
    //
    let labelWidthSum = 0;

    $(".fs-label", $element).each(function () {
        // Get the largest width of the 2 labels.
        const elemWidth = $(this).outerWidth();

        if (_.isUndefined(labelWidthSum)) {
            labelWidthSum = elemWidth;
        } else if (labelWidthSum < elemWidth) {
            labelWidthSum = elemWidth;
        }
    });

    // Add in the size of the button element
    labelWidthSum += $(".fs-btn", $element).outerWidth();

    // add 20px of padding here instead of CSS since the label and button elements
    // are position: absolute
    labelWidthSum += 20;

    $element.css("width", labelWidthSum + "px");
};

/**
 * A flipswitch widget to easily indicate when a value is "On" or "Off". This binding
 * will take an observable as an argument and changes its value between true and
 * false as a user interacts with the widget.
 *
 * # Required Arguments
 *
 * @param {Boolean or Object} value - An observable that will be updated with the boolean state
 *  of the flipswitch as the user interacts with it. This argument can be passed in
 *  as the only argument to the binding or as the "value" attribute to the argument
 *  object.
 *
 * # Options:
 *    @param {String} onLabelKey: localization key for the text to display for the ON state
 *    @param {String} offLabelKey: localization key for the text to display for the OFF state
 *    @param {Boolean|Function} disabled: true if this control is in a 'disabled' state. Default = not disabled
 *
 * # Example
 *
 * <div data-bind="flipswitch: myObservable"></div>
 */
ko.bindingHandlers.flipswitch = {
    init: function (element, valueAccessor) {
        const $element = $(element);
        const bindingData = valueAccessor();
        const value = _.isPlainObject(bindingData)
            ? bindingData.value
            : bindingData;

        if (_.isUndefined(value)) {
            throw new Error(
                "flipswitch binding requires a reference to an observable or an object with a 'value' attribute as its argument."
            );
        }

        const subscription = value.subscribe(function () {
            $element.addClass(FLIPSWITCH_ANIMATION_CLASS);
        });
        // Create the DOM for the flipswitch UI
        createFlipswitchDOM($element, bindingData);

        $element.on(
            "keypress" + EVENT_NAMESPACE + " click" + EVENT_NAMESPACE,
            function (e) {
                if ($element.hasClass(FLIPSWITCH_DISABLED_CLASS)) {
                    return;
                }
                if (
                    e.type === "keypress" &&
                    !(
                        e.keyCode === keyCode.ENTER ||
                        e.keyCode === keyCode.SPACE
                    )
                ) {
                    return;
                }

                $element.focus();
                const isOn = ko.unwrap(value);
                if (isOn) {
                    value(false);
                } else {
                    value(true);
                }

                // Trigger the change event to ensure that other bindings see that the
                // element's value has changed.
                ko.utils.triggerEvent(element, "change");
            }
        );
        // Clean up the binding handler when the element is removed from the DOM.
        ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
            $element.off(EVENT_NAMESPACE);
            subscription.dispose();
        });
    }, // end init()
    update: function (element, valueAccessor) {
        const bindingData = valueAccessor();
        const value = _.isPlainObject(bindingData)
            ? ko.unwrap(bindingData.value)
            : ko.unwrap(bindingData);
        const $element = $(element);
        const isDisabled = ko.unwrap(bindingData.disabled);

        // Update the class' value based on the 'value' binding
        if (value) {
            setOn($element);
        } else {
            setOff($element);
        }

        // Manage the 'disabled' binding
        if (isDisabled) {
            $element.addClass(FLIPSWITCH_DISABLED_CLASS);
            $element.attr("disabled", true);
            $element.removeAttr("tabIndex");
            $element.find("button").attr("disabled", true);
            $element.find("button").removeAttr("tabIndex");
        } else {
            $element.removeClass(FLIPSWITCH_DISABLED_CLASS);
            $element.removeAttr("disabled");
            $element.attr("tabIndex", 0);
            $element.find("button").removeAttr("disabled");
            $element.find("button").attr("tabIndex", -1);
        }

        // give some time for animation to complete prior to removing animation class
        _.delay(function () {
            $element.removeClass(FLIPSWITCH_ANIMATION_CLASS);
        }, 100);
    }, // end update()
}; // end flipswtich()
